import { lazy, Suspense } from 'react';
import { useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router';

import { LoadingState } from '@/shared/ui';

import type { BoardOutletContext } from './BoardPage';

// The card popup (Markdown renderer, editors) is a separate chunk.
const CardDialog = lazy(() =>
  import('@/features/card-details').then((module) => ({ default: module.CardDialog })),
);

/** `/app/boards/:boardId/cards/:cardId`: the card popup over its board (linkable). */
export function CardRoute() {
  const navigate = useNavigate();
  const { boardId = '', cardId = '' } = useParams();
  const { detail } = useOutletContext<BoardOutletContext>();
  const [searchParams] = useSearchParams();
  return (
    <Suspense fallback={<LoadingState />}>
      <CardDialog
        key={cardId}
        cardId={cardId}
        board={detail}
        // Closing keeps the board filter (it lives in the query string).
        onClose={() =>
          void navigate({ pathname: `/app/boards/${boardId}`, search: searchParams.toString() })
        }
      />
    </Suspense>
  );
}
